import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useToasts } from "react-toast-notifications"
import useNavigator from "./useNavigator"
import { useNotifications } from "./useNotifications"
import { useWebProvider } from "./useWebProvider"
import { basicController } from "../../Http/basicController"
import { endPointTimer, endPointUser, paths } from "../../models/constantes"
import { eraseCached } from "../../Reducers/commons-reducers/cachedReducer"
import { setCachedUnidades } from "../../Reducers/commons-reducers/unidadeReducer"
import {
	logIn,
	setCompany,
	setCompanySetores,
} from "../../Reducers/default-reducers/globalConfigReducer"
import { setSavedTimers } from "../../Reducers/default-reducers/timerReducer"
import { useUserService } from "../../Services/default/userService"

const useLogin = () => {
	const [email, setUsuario] = useState("")
	const [password, setSenha] = useState("")
	const [token, setToken] = useState("")
	const global = useSelector((state) => state.global)
	const navigate = useNavigator()
	const toastManager = useToasts()
	const dispatch = useDispatch()
	const { connectSocket, connectNotificationSocket } = useWebProvider()
	const { loadInitialNotifications } = useNotifications()
	const { authOnSGP, loginFromToken } = useUserService()
	const isAuth = global.isAuth

	const preAuthHandler = async (res, redirect = false, customEmail = email, customPassword = password) => {
		let authData = res
		if (authData?.company) {
			setToken(authData.token)
			await authHandler(authData.company, redirect, customEmail, customPassword, authData.token)
		}
	}

	const connect = (userName, company, userId) => {
		// conecta ao socket de matchingObjects
		connectSocket(userName, company)
		// conecta ao socket de notificações
		connectNotificationSocket(userName, company)
		// carrega as notificações não lidas do usuário
		loadInitialNotifications(userId)
	}

	const authHandler = async (
		companyObj,
		redirectedToken = false,
		customEmail = email,
		customPassword = password,
		customToken = token
	) => {
		!isAuth && dispatch({ type: "eraseStore" })

		let companyStr = companyObj?.identifier || companyObj?.company;
		let companyId = companyObj?.id || companyObj?.companyId;
		let companyName = companyObj?.nome || companyObj?.companyName;

		dispatch(setCompany(companyStr))

		const requestData = {
			email: customEmail,
			password: customPassword,
			company: companyStr,
			token: customToken,
			companyId: companyId,
			companyName: companyName
		};

		const response = redirectedToken
			? await loginFromToken(redirectedToken)
			: await authOnSGP(requestData);

		if (!companyStr) {
			companyStr = response?.identifier || response?.company;
		}
		if (!companyId) {
			companyId = response?.companyId || response?.id;
		}

		if (response?.token) {
			const { userName } = response
			if (!isAuth) {
				let unidades = []
				try {
					unidades = await basicController("unidade").readAll(
						"unidade",
						{
							Authorization: response.token,
						}
					) || []
				} catch (error) {
					console.error("Failed to fetch units during login:", error)
				}

				let setores = []
				try {
					setores = await basicController("user").get(
						`findSetoresByCompanyId/${companyId}`,
						{
							Authorization: response.token,
						}
					) || []
				} catch (error) {
					console.error("Failed to fetch setores during login:", error)
				}

				let savedTimers = []
				try {
					savedTimers = await basicController(
						null,
						endPointTimer
					).get(`savedTimer/companie/${companyStr}`, {
						Authorization: response.token,
					}) || []
				} catch (error) {
					console.error("Failed to fetch saved timers during login:", error)
				}

				dispatch(setSavedTimers(savedTimers))
				dispatch(setCompanySetores(setores))
				dispatch(eraseCached(unidades))
				dispatch(setCachedUnidades(unidades))
			}

			dispatch(logIn({ ...response, companyId }))

			connect(userName, companyStr, response.id)

			return response;
		} else {
			toastManager.addToast("Usuario Inexistente", {
				appearance: "error",
				autoDismiss: true,
			})
			return null;
		}
	}

	const authPlataform = (customEmail, customPassword) => {
		const userE = typeof customEmail === 'string' ? customEmail : email;
		const userP = typeof customPassword === 'string' ? customPassword : password;

		return basicController("user", endPointUser)
			.post("authPlataform", { email: userE, password: userP })
			.then((res) => {
				return preAuthHandler(res, false, userE, userP)
			})
			.catch((error) => navigate("/ServidorError"))
	}

	return {
		email,
		setUsuario,
		password,
		setSenha,
		authPlataform,
		preAuthHandler,
		authHandler
	}
}

export default useLogin
